import { Injectable, computed, signal } from '@angular/core';
import { GetAuthProfileResponse } from './authenticate.service';

export type UserProfile = GetAuthProfileResponse['data'];

@Injectable({
    providedIn: 'root'
})
export class UserService {
    // Store the user profile in a signal for reactive updates across the app
    private profileSignal = signal<UserProfile | null>(null);

    // Expose a readonly computed version for components to subscribe to
    public currentUser = computed(() => this.profileSignal());

    constructor() { }

    /**
     * Update the user profile data
     */
    setProfile(profile: UserProfile): void {
        this.profileSignal.set(profile);
    }

    /**
     * Clear the user profile (e.g. on logout)
     */
    clearProfile(): void {
        this.profileSignal.set(null);
    }
}
